import { createContext } from 'react';

const contaContext = createContext();

export default contaContext;
